var SvgPanZoom = require('./svg-pan-zoom.js');

module.exports = SvgPanZoom;



//////////////////
// WEBPACK FOOTER
// /Users/frontend-dev/Desktop/ESM/elit_stroy_front/~/svg-pan-zoom/src/browserify.js
// module id = 155
// module chunks = 0